
import {
    Box, TextField, FormControl, InputAdornment, InputLabel, Input, IconButton, Button,
    Typography, Select, MenuItem, FormHelperText, Alert, Chip, Popover
} from '@mui/material';
import { AccountCircleOutlined, Visibility, VisibilityOff, LockOutlined, Group } from '@mui/icons-material';
import { useState, useEffect } from 'react';
import { useSelector, useDispatch, } from 'react-redux';
import { set } from 'lodash';
import { Tabs } from '../../components/tabs';
import { Grid } from '../../components/table';
import { CONFIG } from '../../../config'
import axios from 'axios';
import { ToolBar } from '../../components/toolbar';
import { Modal } from '../../components/modal';
import { FormA } from '../../components/form';
import moment from 'moment';
import {getFormState} from '../../../helpers/form';
import dayjs from 'dayjs';
import IosShareIcon from '@mui/icons-material/IosShare';
const durationPulgin = require('dayjs/plugin/duration')
dayjs.extend(durationPulgin)
const API_HOST = CONFIG.modules['accounts'].host



const items = {
    'Attendance': {
        name: 'Attendance',
        view: ''
    },

}

const fields = [
    {
        type: 'text',
        label: 'Employee Name',
        required: true,
        name: 'name'
    },
    {
        type: 'text',
        label: 'Email',
        required: true,
        name: 'email'
    },
    {
        type: 'text',
        label: 'Phone',
        required: true,
        name: 'phone'
    },
    {
        type: 'password',
        label: 'Password',
        required: true,
        name: 'password'
    },
    {
        type: 'group',
        items: [
            {
                type: 'date',
                label: 'Date of Birth',
                required: true,
                name: 'dob',
                defaultValue: dayjs('2022-04-17')
            },
            {
                type: 'date',
                label: 'Date of Joining',
                required: true,
                name: 'dateOfJoining',
                defaultValue: dayjs('2022-04-17')
            },
        ]
    },
    {
        type: 'select',
        label: 'Roles',
        required: true,
        name: 'roles',
        multiple: true,
        option: { key: 'roles', value: '_id', label: 'name' }

    },
  
    {
        type: 'select',
        label: 'Designation',
        option: { key: 'Designations', value: '_id', label: 'name' },
        required: true,
        name: 'designation',
        multiple: true
    },
    {
        type: 'select',
        label: 'Departments',
        option: { key: 'Departments', value: '_id', label: 'name' },
        required: true,
        name: 'departments',
        multiple: true
    },
    {
        type: 'select',
        label: 'Languages',
        option: { key: 'Languages', value: '_id', label: 'name' },
        name: 'languages',
        multiple: true
    },
    {
        type: 'select',
        label: 'Districts',
        option: { key: 'Districts', value: '_id', label: 'name' },
        name: 'district'
    },
    {
        type: 'select',
        label: 'Reporting Manager',
        option: { key: 'users', value: '_id', label: 'name' },
        name: 'reportingManager'
    },
    {
        type: 'select',
        label: 'POC',
        option: { key: 'users', value: '_id', label: 'name' },
        name: 'pocForLeaves'
    },
]

export const TodaysAttendance = (props) => {
    const { roles, user, users, Designations, Departments, Languages, Districts } = useSelector((state) => (state.user || {}))
    const userStore = useSelector((state) => (state.user || {}))

    const [active, setActive] = useState('Attendance')
    const [data, setData] = useState(users||[])
    const [open, setOpen] = useState(false)
    const [action, setAction] = useState('new')
    const [saved, setSaved] = useState(null);
    const [index, setIndex] = useState(null);
    const [openConfirm, setOpenConfirm] = useState(false)
    const [formData, setFormData] = useState(getFormState(fields))
    const [filter, setFilter] = useState({
        date: dayjs()
    })
    const [anchorEl, setAnchorEl] = useState(null);
    const openP = Boolean(anchorEl);
    const [rangeData, setRangeData] = useState({});
    const [selected, setSelected] = useState(null)


    const exportDataByUser = () => {
        axios.get(API_HOST + `/export-attendance-by-user?user=${selected.user._id}&from=${encodeURIComponent(dayjs(rangeData.from).format('YYYY-MM-DD'))}&to=${encodeURIComponent(dayjs(rangeData.to).format('YYYY-MM-DD'))}`, {
            responseType: 'arraybuffer'
        }).then((resp) => {
            if (resp) {
                const url = window.URL.createObjectURL(new Blob([resp.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download',`Attendance_Report_${selected.name}.xlsx`);
            document.body.appendChild(link);
            link.click();
               console.log(resp)
            link.remove()
            }
        }).catch((e) => {
            console.log(e)
        })
    }

 
    const fetchAttendance = () => {
        setData([])
        axios.get(API_HOST + '/attendance?forDate='+encodeURIComponent(dayjs(filter.date).format('YYYY-MM-DD'))).then((resp) => {
            if (resp.data && resp.data.success) {
                setData(resp.data.data.map((u)=> {
                    u.name = u.user.name
                    return u
                }))
            }
        }).catch((e) => {
            console.log(e)
        })
    }

    useEffect(()=> {
        fetchAttendance()
    }, [filter.date])

    useEffect(() => {
        fetchAttendance()
    }, [active])

    useEffect(() => {
    }, [Designations])

    useEffect(() => {
    }, [userStore])

    const handleSubmit = () => {
        axios.post(API_HOST , {
            user: {...formData} 
        }).then((resp) => {
            if (resp.data && resp.data.success) {
                setOpen(false)
                setData([resp.data.data, ...data])
            }
        }).catch((e) => {
            console.log(e)
        })
    }

    const handleEdit = () => {
        if(formData.password == '') {
            delete formData.password
        }
        axios.put(API_HOST + `/${saved._id}`, {
            user: formData
        }).then((resp) => {
            if (resp.data && resp.data.success) {
                setOpen(false)
                data[index] = resp.data.user
                setData([...data])
            }
        }).catch((e) => {
            console.log(e)
        })
    }

    const handleDelete = () => {
        axios.delete(API_HOST + '/'+saved._id).then((resp) => {
            if (resp.data && resp.data.success) {
                setOpenConfirm(false)
                data.splice(index, 1)
                setData([...data])
            }
        }).catch((e) => {
            console.log(e)
        })
    }

    const exportData = () => {
        axios.get(API_HOST + `/export-attendance?forDate=${encodeURIComponent(dayjs(filter.date).format('YYYY-MM-DD'))}`, {
            responseType: 'arraybuffer'
        }).then((resp) => {
            if (resp) {
                const url = window.URL.createObjectURL(new Blob([resp.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download',`Attendance_Report_${dayjs(filter.date||new Date()).format('DD-MM-YYYY')}.xlsx`);
            document.body.appendChild(link);
            link.click();
               console.log(resp)
            link.remove()
            }
        }).catch((e) => {
            console.log(e)
        })
    }
    return (
        <>
            {/* <Tabs items={items} active={active} onChange={(key) => {
                setActive(key)
            }} /> */}
            <ToolBar name={active} buttons={[
                {
                    name: 'Export',
                    // type: 'chip',
                    icon: ()=><IosShareIcon sx={{fontSize: '1.2em'}}/>,
                    onClick: () => {
                        exportData()
                    }
                }
            ]}
            

            
            filters={[
                {
                    field: {
                        name: 'date',
                        type:'date',
                        label:'Date',
                    },
                    onChange: (name, value) => {
                        filter[name] = value
                        setFilter({...filter})
                    },
                    state: filter
                    
                }
            ]} />
            <Box sx={{ mt: 2 }}>
                <Grid data={data} columns={[
                    { id: 'name', label: 'Name', minWidth: 170 },
                    { id: 'status', label: 'Status', minWidth: 170, format: (data) => {
                        return data?<Chip label={data} size="small" color={(data=='absent'?'warning':(data=='present'?'success':'error'))} variant="outlined"/>:''
                    } },
                    { id: 'seconds', label: 'Duration', minWidth: 170 , format: (data)=> {
                        return data?dayjs.duration(data * 1000).format('HH:mm:ss'):'00:00:00'
                    }},
                    { id: 'leaveRequest', label: 'Leave Application', minWidth: 170, format: (data,row) => '' },
                    { id: 'checkIn', label: 'CheckInTime', minWidth: 170, format: (data, row) => {
                        return data ? dayjs(data).format('HH:mm:ss') : '-'
                    } },
                    { id: 'checkOut', label: 'LastCheckOutTime', minWidth: 170, format: (data, row) => {
                        return data ? dayjs(data).format('HH:mm:ss') : '-'},
                    },
                    { id: '_id', label: 'Action', minWidth: 70, format: (data, row) => {
                        return (
                            <Button onClick={(e)=>{
                                setSelected(row)
                                setRangeData({
                                    from: dayjs(),
                                    to: dayjs(),
                                });
                                setAnchorEl(e.currentTarget);

                            }}>Report</Button>
                        )
                    }
                    }
                ]}
                
                    ></Grid>
            </Box>
            <Modal open={open}
                handleClose={() => { setOpen(false) }}
                head={`${action == 'new' ? 'Add' : 'Edit'} ${active}`}
                buttons={[
                    {
                        name: 'Cancel',
                        onClick: () => {
                            setOpen(false)
                        }
                    },
                    {
                        name: action == 'new' ? 'Create' : 'Save',
                        onClick: () => {
                            switch (action) {
                                case 'new':
                                    handleSubmit()
                                    break;
                                case 'edit':
                                    handleEdit()
                                    break;
                                default: break;
                            }
                        }
                    }
                ]}

            >
                 {
                    action == 'edit' &&
                    <Typography variant='p' color="grey">{
                        'ID: ' + saved._id
                    }</Typography>
                }
                {
                    Array.isArray(fields) &&
                    <FormA fields={fields}
                        data={{ roles, Designations, Districts, Languages, Departments, users }}
                        onChange={(name, value, multiple) => {
                            formData[name] = value
                            setFormData({ ...formData })
                        }}
                        state={formData||{}}
                    />
                }
               

            </Modal>

            <Modal open={openConfirm}
                handleClose={() => { setOpen(false) }}
                head={`${'Delete'} ${active}`}
                desc={`Please confirm to delete the following ${active}?`}
                buttons={[
                    {
                        name: 'Cancel',
                        onClick: () => {
                            setOpenConfirm(false)
                        }
                    },
                    {
                        name: 'Delete',
                        onClick: () => {
                            handleDelete()
                        }
                    }
                ]}

            >
                {
                    saved &&
                    <Box>
                        <Typography variant='p' color="grey">{'ID: ' + saved._id}</Typography><br></br>
                        <Typography variant='p' color="grey">{'Name: ' + saved.name}</Typography>
                    </Box>
                }

            </Modal>

            <Popover
				id={"report-range"}
				open={openP}
				anchorEl={anchorEl}
				onClose={() => setAnchorEl(null)}
				anchorOrigin={{
					vertical: "center",
					horizontal: "center",
				}}
				transformOrigin={{
					vertical: "top",
					horizontal: "left",
				}}
			>
				<Box sx={{ padding: 2, borderRadius: 2 }}>
					<FormA
						fields={[
							{
								type: "date",
								label: "From",
								required: true,
								name: "from",
								defaultValue: dayjs(),
								shouldDisableDate: (d) => {
									return (
										dayjs(d).isAfter(dayjs()) || dayjs(d).isAfter(rangeData.to)
									);
								},
							},
							{
								type: "date",
								label: "To",
								required: true,
								name: "to",
								defaultValue: dayjs(),
								shouldDisableDate: (d) => {
									return (
										dayjs(d).isAfter(dayjs()) || dayjs(d).isBefore(rangeData.from)
									);
								},
							},
						]}
						data={{}}
						onChange={(name, value, multiple) => {
							const newRange = { ...rangeData };
							newRange[name] = dayjs(value);
							setRangeData(newRange);
						}}
						state={rangeData}
					/>
					
					<Button
						onClick={() => {

                            exportDataByUser()
						}}
					>
						{"Export"}
					</Button>
				</Box>
			</Popover>
        </>
    )
}